import React from 'react';

import { InputRadio, InputRadioProps } from './InputRadio';
import styles from './InputRadioList.module.scss';

export interface InputRadioListProps {
  name: string;
  items: InputRadioProps[];
  label?: string;
  darkMode?: boolean;
  registerOptions?: any;
  hasErrors?: boolean;
  size?: 'small' | 'medium';
}

export const InputRadioList: React.FC<InputRadioListProps> = ({
  name,
  items,
  label,
  darkMode,
  registerOptions,
  hasErrors,
  size,
}) => (
  <div className={`${styles.container} ${hasErrors ? styles.error : ''}`}>
    {label && <div className={styles.label}>{label}</div>}
    {items.map((item) => (
      <InputRadio
        darkMode={darkMode}
        registerOptions={registerOptions}
        key={item.value}
        name={name}
        icon={item.icon}
        iconColor={item.iconColor}
        iconSize={item.iconSize}
        iconType={item.iconType}
        title={item.title}
        subtitle={item.subtitle}
        value={item.value}
        disabled={item.disabled}
        link={item.link}
        size={size}
      />
    ))}
  </div>
);
